import { NgxsConfig } from '@ngxs/store';
import { NgxsDevtoolsOptions } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginOptions } from '@ngxs/logger-plugin';
import { environment } from 'environments/environment';
import { EnumAmbiente } from '@env/enum-ambiente';

export const STATES_MODULES = [];

export const OPTIONS_CONFIG: Partial<NgxsConfig> = {
    developmentMode: environment.ambiente === EnumAmbiente.Desenvolvimento,
    // Mantém o comportamento das versões 3.x: erros dentro de seletores retornam undefined em vez de
    // serem lançados (a partir da 18 o padrão passou a ser lançar o erro).
    selectorOptions: { suppressErrors: true }
};

export const DEVTOOLS_REDUX_CONFIG: NgxsDevtoolsOptions = {
    disabled: environment.ambiente !== EnumAmbiente.Desenvolvimento
};

export const LOGGER_CONFIG: NgxsLoggerPluginOptions = {
    disabled: environment.ambiente !== EnumAmbiente.Desenvolvimento
};
